import moment from 'moment'
import Vue from 'vue'
// 防抖
/* eslint-disable */
export function _debounce(fn, delay = 5000) {
  let timer
  return function() {
    const self = this
    const args = arguments
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(function() {
      timer = null
      fn.apply(self, args)
    }, delay)
  }
}
// 节流
export function _throttle(fn, interval = 5000) {
  let last
  let timer
  return function() {
    const self = this
    const args = arguments
    const now = +new Date()
    if (last && now - last < interval) {
      clearTimeout(timer)
      timer = setTimeout(function() {
        last = now
        fn.apply(self, args)
      }, interval)
    } else {
      last = now
      fn.apply(self, args)
    }
  }
}

export function _formatTime(time) {
  // 时间戳转换为转换为多少天多少小时多少秒
  const tempTime = moment.duration(time)
  const hours = parseInt(tempTime.asHours(), 0)
  const days = parseInt(tempTime.asDays(), 0)
  const minutes = parseInt(tempTime.asMinutes(), 0)
  if (days >= 1) {
    return `${days}天${tempTime.hours()}小时${tempTime.minutes()}分钟${tempTime.seconds()}秒`
  }
  if (hours >= 1) {
    return `${hours}小时${tempTime.minutes()}分钟${tempTime.seconds()}秒`
  }
  if (minutes >= 1) {
    return `${minutes}分钟${tempTime.seconds()}秒`
  }
  return `${tempTime.seconds()}秒`
}

Vue.prototype.formatTime = _formatTime

// 页面el-upload上传的图片转化为base64
export function _getBase64Image(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    let imgResult = ''
    reader.readAsDataURL(file)
    reader.onload = () => {
      imgResult = reader.result
    }
    reader.onerror = (error) => {
      reject(error)
    }
    reader.onloadend = function() {
      resolve(imgResult)
    }
  })
}

//第一个参数就是原来的字符串，第二个是宽度，第三个就是回调方法
export function cutImageBase64(base64, w, callback, img) {
  var newImage = new Image()
  var quality = 0.6 //压缩系数0-1之间
  newImage.src = base64
  newImage.setAttribute('crossOrigin', 'Anonymous') //url为外域时需要
  var imgWidth, imgHeight
  newImage.onload = function() {
    imgWidth = this.width
    imgHeight = this.height
    var canvas = document.createElement('canvas')
    var ctx = canvas.getContext('2d')
    if (Math.max(imgWidth, imgHeight) > w) {
      if (imgWidth > imgHeight) {
        canvas.width = w
        canvas.height = (w * imgHeight) / imgWidth
      } else {
        canvas.height = w
        canvas.width = (w * imgWidth) / imgHeight
      }
    } else {
      canvas.width = imgWidth
      canvas.height = imgHeight
      quality = 0.6
    }
    ctx.clearRect(0, 0, canvas.width, canvas.height)
    ctx.drawImage(this, 0, 0, canvas.width, canvas.height)
    var base64 = canvas.toDataURL('image/jpeg', quality) //压缩语句
    // 如想确保图片压缩到自己想要的尺寸,如要求在50-150kb之间，请加以下语句，quality初始值根据情况自定
    while (base64.length / 1024 > 150) {
      quality -= 0.01
      base64 = canvas.toDataURL('image/jpeg', quality)
    }
    // 防止最后一次压缩低于最低尺寸，只要quality递减合理，无需考虑
    while (base64.length / 1024 < 50) {
      quality += 0.001
      base64 = canvas.toDataURL('image/jpeg', quality)
    }
    callback(base64, img) //必须通过回调函数返回，否则无法及时拿到该值
  }
}
